'use client';
import ErrorComponent from './error';

export default function NotFound() {
  const error = new Error('404');
  return <ErrorComponent error={error} />;
}
